import React, { useState, useEffect } from 'react';
import { X, Frown } from 'lucide-react';

const COMMON_REASONS = [
  "Budget Issues",
  "Went with Competitor",
  "Changed Mind",
  "Unresponsive",
  "Not a Fit",
  "Other"
];

const DealLostModal = ({ isOpen, onClose, onConfirm, leadName }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSelectedReason('');
      setOtherReason('');
    }
  }, [isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedReason) return;
    
    const finalReason = selectedReason === 'Other' ? otherReason : selectedReason;
    if (!finalReason.trim()) return;

    onConfirm({ lost_reason: finalReason });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-red-100 flex items-center justify-center text-red-600">
              <Frown size={20} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900" style={{ fontFamily: 'Inter, sans-serif' }}>Deal Lost</h3>
              <p className="text-sm text-gray-500">Record lost reason for <span className="font-medium text-gray-700">{leadName}</span></p>
            </div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-2 rounded-full transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="px-6 py-6 space-y-5">
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">Why was this deal lost?</label>
            <div className="flex flex-wrap gap-2">
              {COMMON_REASONS.map(reason => (
                <button
                  key={reason}
                  type="button"
                  onClick={() => setSelectedReason(reason)}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
                    selectedReason === reason 
                      ? 'bg-red-50 border-red-200 text-red-700' 
                      : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {reason}
                </button>
              ))}
            </div>
          </div>

          {selectedReason === 'Other' && (
            <div className="animate-in slide-in-from-top-2 duration-200">
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">Please specify</label>
              <textarea
                required
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                placeholder="Details about why the deal was lost..."
                rows="3"
                className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
              />
            </div>
          )}

          {/* Footer Actions */}
          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 border border-gray-200 rounded-xl transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!selectedReason || (selectedReason === 'Other' && !otherReason.trim())}
              className="px-6 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl transition-colors shadow-sm"
            >
              Save Details
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DealLostModal;
